"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var updatePassword = function updatePassword(client) {
  return function (data) {
    return client.user.updatePassword(data);
  };
};
var _default = exports["default"] = updatePassword;
module.exports = exports["default"];